/*
 * Header auto-hide no mobile (<=989px).
 * Esconde o topo (barra de anúncios + navbar) ao rolar para baixo e reaparece
 * ao rolar para cima, alternando .ohli-nav-hidden no <body>. Mantém visível
 * perto do topo e quando há um overlay aberto no header (menu drawer / busca).
 * Estilos em ohli-custom.css.
 */
(function () {
  var mq = window.matchMedia('(max-width: 989px)');
  var header = document.querySelector('.section-header');
  if (!header) return;
  var lastY = window.pageYOffset || document.documentElement.scrollTop;
  var ticking = false;
  var THRESHOLD = 6; // ignora micro-scrolls
  var REVEAL_AT_TOP = 80; // sempre visível perto do topo

  function overlayOpen() {
    return !!header.querySelector('details[open]');
  }

  function frame() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (!mq.matches || overlayOpen() || y <= REVEAL_AT_TOP) {
      document.body.classList.remove('ohli-nav-hidden');
      lastY = y;
      return;
    }
    var dy = y - lastY;
    if (dy > THRESHOLD) {
      document.body.classList.add('ohli-nav-hidden'); // rolando p/ baixo → esconde
      lastY = y;
    } else if (dy < -THRESHOLD) {
      document.body.classList.remove('ohli-nav-hidden'); // rolando p/ cima → mostra
      lastY = y;
    }
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(frame);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  mq.addEventListener('change', function () {
    if (!mq.matches) document.body.classList.remove('ohli-nav-hidden');
  });
})();
